


































import { defineComponent, useRoute } from '~/utils/nuxt3-migration'

export default defineComponent({
  setup() {
    const route = useRoute()

    function onLogoClick(e: Event) {
      if (route.value.name === '__index') {
        // do a hard refresh in this case
        e.preventDefault()
        window.location.reload()
      }
    }
    return {
      onLogoClick
    }
  }
})
